import { z } from 'zod'
import type { Hex } from '../../types'
import { addressPrimitiveSchema, txHashSchema } from '../../types/primitive'
import type { ContractCreation } from '../types'
import type { KaiascanClient } from './client'

type GetContractCreationParameters = {
  client: KaiascanClient
  address: Hex
  headers?: Record<string, string>
}

const resultSchema = z.array(
  z.object({
    contractAddress: addressPrimitiveSchema,
    contractCreator: addressPrimitiveSchema,
    txHash: txHashSchema,
  }),
)

/**
 * Kaiascan から contract creation 情報を取得する。
 *
 * @param parameters - client、contract address、headers。
 * @returns contract creation の配列。
 */
export const getContractCreation = async ({
  client,
  address,
  headers,
}: GetContractCreationParameters): Promise<ContractCreation[]> => {
  try {
    return await client.get({
      path: '',
      query: {
        module: 'contract',
        action: 'getcontractcreation',
        contractaddresses: address,
      },
      resultSchema,
      headers,
    })
  } catch (error) {
    if (error instanceof Error && error.message.includes('No data found')) {
      return []
    }
    throw error
  }
}
